/* Poplar Bluff Trailer — collection page behavior */
(function () {
  'use strict';

  /* ---- List / grid view toggle (persisted) ---- */
  var cards = document.querySelector('[data-cards]');
  function applyView(mode) {
    if (!cards) return;
    cards.classList.toggle('grid-view', mode === 'grid');
    document.querySelectorAll('[data-view]').forEach(function (b) {
      b.classList.toggle('on', b.getAttribute('data-view') === mode);
    });
    try { localStorage.setItem('pbt-results-view', mode); } catch (e) {}
  }
  document.querySelectorAll('[data-view]').forEach(function (b) {
    b.addEventListener('click', function () { applyView(b.getAttribute('data-view')); });
  });
  if (cards) {
    var saved = 'grid';
    try { saved = localStorage.getItem('pbt-results-view') || cards.getAttribute('data-default-view') || 'grid'; } catch (e) {}
    applyView(saved);
  }

  /* ---- Filter group accordions ---- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('[data-fg-head]');
    if (head) head.closest('.filter-grp').classList.toggle('closed');
  });

  /* ---- Mobile filter drawer ---- */
  var sidebar = document.querySelector('[data-sidebar]');
  document.addEventListener('click', function (e) {
    if (!sidebar) return;
    if (e.target.closest('[data-filter-open]')) { sidebar.classList.add('open'); document.body.style.overflow = 'hidden'; }
    if (e.target.closest('[data-filter-close]') || e.target === sidebar) { sidebar.classList.remove('open'); document.body.style.overflow = ''; }
  });

  /* ---- Auto-submit sort + filter checkboxes ---- */
  document.querySelectorAll('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () {
      var form = el.closest('form');
      if (form) form.submit();
    });
  });

  /* ---- Monthly payment estimates on cards ---- */
  function payment(principal, months, aprPct) {
    var r = (aprPct / 100) / 12;
    if (r === 0) return principal / months;
    return principal * r / (1 - Math.pow(1 + r, -months));
  }
  document.querySelectorAll('[data-est-monthly]').forEach(function (el) {
    var p = parseFloat(el.getAttribute('data-price')) || 0;
    var a = parseFloat(el.getAttribute('data-apr')) || 8.99;
    var t = parseFloat(el.getAttribute('data-term')) || 60;
    el.textContent = Math.round(payment(p, t, a)).toLocaleString();
  });
})();
